import React from "react";

import { PublisherAPI } from "apis";
import GeoCountrySelector from "../../GeoCountrySelector";

import {
  inputClass,
  buttonModalCancelClass,
  buttonModalConfirmClass,
} from "helpers/StyleClass";
import { MESSAGE } from "constants/Message";
import { validateEmail } from "helpers/Utils";

class CreateReseller extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      msg: [],
      isSaving: false,

      name: "",
      userEmail: "",
      geoCountryId: null,
      pricingCurrency: "",
    };

    this.handleCreateReseller = this.handleCreateReseller.bind(this);
  }

  async handleCreateReseller() {
    this.setState({ msg: [] });

    try {
      const { name, userEmail, geoCountryId, pricingCurrency } = this.state;
      if (!name || name === "") {
        throw "Missing Reseller Name";
      }
      if (!userEmail || userEmail === "") {
        throw "Missing User Email";
      }
      if (!validateEmail(userEmail)) {
        throw "Invalid User Email";
      }
      if (!geoCountryId) {
        throw "Missing Country";
      }
      if (!pricingCurrency || pricingCurrency === "") {
        throw "Missing Pricing Currency";
      }

      const params = {
        name,
        userEmail,
        geoCountryId,
        pricingCurrency,
      };

      this.setState({
        isSaving: true,
      });

      const result = await PublisherAPI.createReseller(params);
      console.log(result);

      this.setState({
        isSaving: false,
        msg: ["Reseller created!", MESSAGE.SUCCESS],
      });

      this.props.handleUpdateData();
    } catch (err) {
      console.log(err);
      this.setState({
        msg: [err.toString(), MESSAGE.ERROR],
        isSaving: false,
      });
    }
  }

  render() {
    const { msg, isSaving, name, userEmail, geoCountryId, pricingCurrency } =
      this.state;

    return (
      <div>
        <div className="rounded mb-4 bg-gray-200 px-4 pb-4 pt-2">
          <div className="mb-4">
            <label className="font-semibold text-gray-800">Reseller Name</label>
            <div>
              <input
                type="text"
                className={inputClass}
                value={name}
                onChange={(e) => this.setState({ name: e.target.value })}
              ></input>
            </div>
          </div>

          <div className="mb-4">
            <label className="font-semibold text-gray-800">User Email</label>
            <div>
              <input
                type="email"
                className={inputClass}
                value={userEmail}
                placeholder="user@company.com"
                onChange={(e) =>
                  this.setState({
                    userEmail: e.target.value,
                  })
                }
              ></input>
            </div>
          </div>

          <div className="mb-4">
            <label className="font-semibold text-gray-800">Country</label>
            <div>
              <GeoCountrySelector
                selectedValue={geoCountryId}
                handleOnChange={(value) =>
                  this.setState({ geoCountryId: value })
                }
              ></GeoCountrySelector>
            </div>
          </div>

          <div className="mb-4">
            <label className="font-semibold text-gray-800">
              Pricing Currency{" "}
              <a
                className="ml-1 text-sm text-blue-600"
                href="https://en.wikipedia.org/wiki/ISO_4217"
                target="_blank"
              >
                (ISO Currency Code List)
              </a>
            </label>
            <div>
              <input
                type="text"
                className={inputClass}
                value={pricingCurrency}
                placeholder="ISO Currency Code ex. TWD"
                onChange={(e) =>
                  this.setState({
                    pricingCurrency: e.target.value.toUpperCase(),
                  })
                }
              ></input>
            </div>
          </div>
        </div>
        <div className="mb-4">
          {msg.length !== 0 && (
            <div
              className={`rounded  p-2 font-semibold  ${
                msg[1] === MESSAGE.SUCCESS
                  ? "bg-green-100 text-green-600"
                  : "bg-red-100 text-red-600"
              }`}
            >
              {msg[0]}
            </div>
          )}
        </div>

        <div className="flex justify-end gap-2">
          {isSaving && <div className="loader"></div>}
          {!isSaving && msg[1] !== MESSAGE.SUCCESS && (
            <>
              <button
                type="button"
                className={buttonModalCancelClass}
                onClick={this.props.handleClose}
              >
                Cancel
              </button>

              <button
                type="button"
                className={buttonModalConfirmClass}
                onClick={this.handleCreateReseller}
              >
                Create Reseller
              </button>
            </>
          )}
          {msg.length !== 0 && msg[1] === MESSAGE.SUCCESS && (
            <button
              type="button"
              className={buttonModalConfirmClass}
              onClick={this.props.handleClose}
            >
              Close
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default CreateReseller;
